import { render } from "./AntiBrushVerify.vue?vue&type=template&id=59d0870b"
import script from "./AntiBrushVerify.vue?vue&type=script&lang=js"
export * from "./AntiBrushVerify.vue?vue&type=script&lang=js"

import "./AntiBrushVerify.vue?vue&type=style&index=0&id=59d0870b&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__